module.exports = "/_next/static/images/kamal-e59ecfac3b5b0e1cb5bd0470bfbf885f.png";